<app-form-box>
	<form [formGroup]="form" (ngSubmit)="onSubmit()">
		@if (setupLinkExpired) {
			<app-form-label>Sign-up link has expired</app-form-label>
			<br />
			<p>This sign-up link has expired. Request a new link to finish creating your account.</p>
			<br />
			<br />
			<app-form-link (click)="onRequestNewSignupLink()">Send a New Sign-Up Link</app-form-link>
		} @else {
			<app-form-label>Set Your Password</app-form-label>

			@if (studentId) {
				<p>Your Student ID is {{ studentId }}.</p>
			}

			<br />

			<app-password-requirements></app-password-requirements>

			<br />

			<app-password-field
				[fg]="form"
				formGroupOrControlName="password"
				label="New Password"
				autocomplete="new-password"
			></app-password-field>

			<br />

			<app-password-field
				[fg]="form"
				formGroupOrControlName="confirmPassword"
				label="Confirm Password"
				autocomplete="new-password"
			></app-password-field>

			<br />

			<app-form-submit-button
				[disabled]="!form.valid || loading || !hasSubmitContext"
				[loading]="loading"
			>
				Save
			</app-form-submit-button>
		}
	</form>

	<div class="footer-links">
		<!--app-form-link (click)="onBack()">Back</app-form-link-->
	</div>
</app-form-box>
